import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "./DetailSection.scss";
import impexp from "../../assets/images/importexportimg.png";
import clientSampleSheet from "../../components/client_template.xlsx";
// import { getCasesByName, getTasks, searchParties } from "../../api/auth.js";
import {
  getCasesByName,
  getDistrictCourtCasesAddedManually,
  getDistrictCourtCasesByCompany,
  getHighCourtCasesAddedManually,
  getHighCourtCasesByCompany,
  getIsCheckedDistrictCourtCasesAddedManually,
  getIsCheckedDistrictCourtCasesByCompany,
  getIsCheckedHighCourtCasesAddedManually,
  getIsCheckedHighCourtCasesByCompany,
  getIsCheckedOtherCourtCasesAddedManually,
  getOtherCourtCasesAddedManually,
  getIsCheckedSupremeCourtCasesByCompany,
  getIsCheckedSupremeCourtCasesAddedManually,
  uploadCasesSpreadsheet,
} from "../../services/api/CasesApi.js";
import {
  getTasks,
  getTasksAssignedByUser,
  getTasksAssignedToUser,
} from "../../services/api/TaskApi.js";
import {
  searchParties,
  searchExpenses,
  searchLabel,
  searchMyClient,
  InvoiceForCompany,
  InvoiceForClient,
  searchNote,
  searchAddedUsers,
  searchHighCaseFetched,
  searchHighCaseManual,
  searchDistrictCaseFetched,
  searchDistrictCaseManual,
} from "../../services/api/SearchApi.js";
import { useSearchResults } from "../../context/SearchResultsContext.js";
import { exportCasesToPDF } from "../exportPdf.js";
import DetailCard from "../DetailCard/DetailCard.js";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoading } from "../../context/LoadingContext.js";
import {
  getMyClients,
  uploadClientsSpreadsheet,
} from "../../services/api/MyClientsApi.js";
import { getLabelsByUser } from "../../services/api/LabelsApi.js";
import { useAuth } from "../../context/AuthContext.js";
import { getallBranchNames } from "../../services/api/BranchApi.js";
import {
  getalllawyersCreatedByMe,
  getUserLimit,
} from "../../services/api/AddUsersApi.js";
import { getNoteByUser } from "../../services/api/NoteApi.js";
import { getExpenseByUser } from "../../services/api/ExpenseApi.js";
import {
  getInvoicesCompany,
  getInvoicesCustomer,
} from "../../services/api/InvoicesApi.js";
import { getHierarchy } from "../../services/api/HierarchyApi.js";
import { exportTasksToExcel } from "../exportTaskstoExcel.js";
import { useCaseSelection } from "../../context/CaseSelectionContext.js";
import {
  getDistrictCourtCustomerCases,
  getHighCourtCustomerCases,
  getOtherCourtCustomerCases,
  getSupremeCourtCustomerCases,
} from "../../services/api/CustomerDashApi.js";
import { useToast } from "../../context/ToastContext";
import CommonModal from "../CommonModal/CommonModal.js";
import { ExportInvoicetoExcel } from "../ExportInvoicetoExcel.js";
import { BranchForm } from "../../forms/BranchForm/BranchForm.js";
import { useGlobalSettings } from "../../context/GlobalSettingsContext.js";
import { useTaskSelection } from "../../context/TaskSelectionContext.js";
import { useInvoiceSelection } from "../../context/InvoiceSelectionContext.js";
import { useLabelSelection } from "../../context/LabelSelectionContext.js";
import { useNoteSelection } from "../../context/NoteSelectionContext.js";
import { useExpenseSelection } from "../../context/ExpenseSelectionContext.js";
import { useUserSelection } from "../../context/UserSelectionContext.js";
import { useClientSelection } from "../../context/ClientSelectionContext.js";
import { useCaseLimit } from "../../context/CaseLimitContext.js";
import caseSampleSheet from "../../components/upload_cases_sample_sheet.xlsx";
import userSampleSheet from "../../components/hdfc_gandhinagar_users_test.xlsx";
import { uploadUsersSpreadsheetUsers } from "../../services/api/AddUsersApi.js";
import { exportClientsToExcel } from "../exportClientsToExcel.js";
import { MdSearch } from 'react-icons/md';
import { getAllGlobalSettingsData } from "../../services/api/GlobalSettingsApi.js";


export const DetailSection = ({ username, activeTab }) => {
  const location = useLocation();
  const [selectedYear, setSelectedYear] = useState("all");
  const isCases = location.pathname === "/home/cases";
  const isTasks = location.pathname === "/home/tasks";
  const isInvoices = location.pathname === "/home/invoices";
  const isMyClients = location.pathname === "/home/my-clients";
  const { company, role } = useAuth();
  const [isInvoiceExportModalOpen, setIsInvoiceExportModalOpen] =
    useState(false);
  const [isPdfExportModalOpen, setIsPdfExportModalOpen] = useState(false);
  const [pdfOrientation, setPdfOrientation] = useState("portrait");
  const companyID = company?._id;
  const [detailSecData, setDetailSecData] = useState([]);
  const [TaskSecData, setTaskSecData] = useState([]);
  const [MyClientsData, setMyClientsData] = useState([]);
  const [LabelData, setLabelData] = useState([]);
  const [ExpenseData, setExpenseData] = useState([]);
  const [NotesData, setNotesData] = useState([]);
  const [InvoiceData, setInvoiceData] = useState([]);
  const [BranchData, setBranchData] = useState([]);
  // Add this state near the top with other state declarations
  const [companyStats, setCompanyStats] = useState(null);

  const [userLimitData, setUserLimitData] = useState(null);
  const [isUserLimitLoading, setIsUserLimitLoading] = useState(false);
  const [totalFilteredCount, setTotalFilteredCount] = useState(0);

  const [hasPerformedSearch, setHasPerformedSearch] = useState(false);
  const activeTabRef = useRef(activeTab);
  useEffect(() => {
    activeTabRef.current = activeTab;
  }, [activeTab]);

  const {
    taskTab,
    selectedCard,
    handleCardClick,
    pagination: taskPagination,
    refreshKey,
    searchTerm: taskSearchTerm,
    setSearchTerm: setTaskSearchTerm
  } = useTaskSelection(); // Updated
  const [isCaseLimitModalOpen, setIsCaseLimitModalOpen] = useState(false);

  // const { setSearchTerm } = useTaskSelection();

  // Use CaseLimitContext instead of local state
  const {
    caseLimitData,
    isLoading: isCaseLimitLoading,
    refreshCaseLimitData,
  } = useCaseLimit();

  const {
    selectedCard: selectedInvoiceCard,
    handleCardClick: handleInvoiceCardClick,
    searchTerm: invoiceSearchTerm,
    setSearchTerm: setInvoiceSearchTerm,
    filters: invoiceFilters,
    setFilters: setInvoiceFilters,
    setFilteredInvoices,
    pagination: invoicePagination,
    updatePaginationInfo: updateInvoicePaginationInfo,
    refreshKey: invoiceRefreshKey,
    buildQueryParams: buildInvoiceQueryParams,
    clearAllFilters: clearInvoiceFilters,
  } = useInvoiceSelection();

  const {
    searchTerm: labelSearchTerm,
    setSearchTerm: setLabelSearchTerm,
    filters: labelFilters,
    setFilters: setLabelFilters,
    filteredLabels,
    setFilteredLabels,
    refreshKey: labelRefreshKey,
    pagination: labelPagination,
    updatePaginationInfo: updateLabelPaginationInfo,
  } = useLabelSelection();

  const {
    searchTerm: expenseSearchTerm,
    setSearchTerm: setExpenseSearchTerm,
    filters: expenseFilters,
    setFilters: setExpenseFilters,
    filteredExpenses,
    setFilteredExpenses,
    hasActiveFilters: hasExpenseFilters,
    pagination: expensePagination,
    updatePaginationInfo: updateExpensePaginationInfo,
    refreshKey: expenseRefreshKey,
  } = useExpenseSelection();

  const {
    searchTerm: userSearchTerm,
    setSearchTerm: setUserSearchTerm,
    filters: userFilters,
    setFilters: setUserFilters,
    filteredUsers,
    setFilteredUsers,
    selectedCard: selectedUserCard,
    handleCardClick: handleUserCardClick,
    hasActiveFilters: hasUserFilters,
    clearAllFilters: clearUserFilters,
    refreshKey: userRefreshKey,
    pagination: userPagination,
    updatePaginationInfo: updateUserPaginationInfo,
  } = useUserSelection();

  // Add this state in your DetailSection component
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [selectedDateRange, setSelectedDateRange] = useState("current-month");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [AddUserData, setAddUserData] = useState([]);
  const [searchdetailSecData, setsearchDetailSecData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const {
    searchResults,
    setSearchResults,
    searchType,
    setSearchType,
    searchMetadata,
    setSearchMetadata,
  } = useSearchResults();
  const {
    selectedCaseType,
    setSelectedCaseType,
    selectedCourtType,
    setSelectedCourtType,
    filteredCases,
    filters,
    setFilters,
    selectedAssignedUser,
    setSelectedAssignedUser,
    selectedLabel,
    selectedCaseCard,
    handleCaseCardClick,
    setFilteredCases,
    isLoading, // Add this
    setIsLoading,
    refreshKey: caseRefreshKey,
    pagination,
    updatePaginationInfo: updateCasePaginationInfo,
    searchTerm: caseSearchTerm,
    setSearchTerm: setCaseSearchTerm,
    triggerCaseRefresh,
  } = useCaseSelection();

  const {
    searchTerm: noteSearchTerm,
    setSearchTerm: setNoteSearchTerm,
    filters: noteFilters,
    setFilters: setNoteFilters,
    filteredNotes,
    setFilteredNotes,
    refreshKey: noteRefreshKey,
    pagination: notePagination,
    updatePaginationInfo: updateNotePaginationInfo,
  } = useNoteSelection();

  const {
    searchTerm: clientSearchTerm,
    setSearchTerm: setClientSearchTerm,
    filters: clientFilters,
    setFilters: setClientFilters,
    filteredClients,
    setFilteredClients,
    hasActiveFilters: hasClientFilters,
    clearAllFilters: clearClientFilters,
    refreshKey: clientRefreshKey,
    pagination: clientPagination,
    updatePaginationInfo: updateClientPaginationInfo,
    triggerClientRefresh,
  } = useClientSelection();

  const [isNewBranchModalOpen, setIsNewBranchModalOpen] = useState(false);
  const [isImportCasesModalOpen, setIsImportCasesModalOpen] = useState(false);
  const [isImportUsersModalOpen, setIsImportUsersModalOpen] = useState(false);
  const { showLoading, hideLoading } = useLoading();
  const navigate = useNavigate();
  const global = useGlobalSettings();
  const avail_currency =
    global?.globalSettings?.result?.[0].expenseSettings?.currency;

  const currencySign = avail_currency === "INR" ? "₹" : "$";

  const limit = 10;
  const page = 1;

  const { showToast } = useToast();
  const [isUserLimitModalOpen, setIsUserLimitModalOpen] = useState(false);

  // useEffect(() => {
  //   if (activeTab === "Cases") {
  //     setCaseSearchTerm(searchInput || "");
  //   }
  //   if (activeTab === "Tasks") {
  //     setSearchTerm(searchInput || "");
  //   }
  //   if (activeTab === "Invoices") {
  //     setInvoiceSearchTerm(searchInput || "");
  //   }
  //   if (activeTab === "Labels") {
  //     setLabelSearchTerm(searchInput || "");
  //   }
  //   if (activeTab === "Notes") {
  //     setNoteSearchTerm(searchInput || "");
  //   }
  //   if (activeTab === "Expenses") {
  //     setExpenseSearchTerm(searchInput || "");
  //   }
  //   if (activeTab === "Manage Users") {
  //     setUserSearchTerm(searchInput || "");
  //   }
  //   if (activeTab === "Add My Clients") {
  //     setClientSearchTerm(searchInput || "");
  //   }
  // }, [
  //   searchInput,
  //   activeTab,
  //   setSearchTerm,
  //   setInvoiceSearchTerm,
  //   setLabelSearchTerm,
  //   setNoteSearchTerm,
  //   setExpenseSearchTerm,
  //   setUserSearchTerm,
  //   setClientSearchTerm,
  //   setCaseSearchTerm,
  // ]);


  // SYNC FIX: When switching tabs, update the local input to match the saved Context state.
  useEffect(() => {
    switch (activeTab) {
      case "Cases":
        setSearchInput(caseSearchTerm || "");
        break;
      case "Tasks":
        setSearchInput(taskSearchTerm || "");
        break;
      case "Invoices":
        setSearchInput(invoiceSearchTerm || "");
        break;
      case "Labels":
        setSearchInput(labelSearchTerm || "");
        break;
      case "Notes":
        setSearchInput(noteSearchTerm || "");
        break;
      case "Expenses":
        setSearchInput(expenseSearchTerm || "");
        break;
      case "Manage Users":
        setSearchInput(userSearchTerm || "");
        break;
      case "Add My Clients":
        setSearchInput(clientSearchTerm || "");
        break;
      default:
        setSearchInput("");
        break;
    }
  }, [
    activeTab,
    // We strictly depend on activeTab. 
    // We intentionally exclude the searchTerms here to avoid a typing loop 
    // (typing -> update context -> update input -> typing).
    // The Input -> Context sync is handled by the debounce effect below.
  ]);
  const buildQueryParams = useCallback(
    (searchTerm) => {
      const params = new URLSearchParams();

      if (searchTerm && searchTerm.trim()) {
        params.set("search", searchTerm.trim());
      }

      // Use shared filters from context
      if (filters.status && filters.status !== "") {
        params.set("status", filters.status);
      }

      if (filters.type && filters.type !== "all") {
        params.set("type", filters.type);
      }

      // FIXED: Add assignedIds parameter
      if (selectedAssignedUser && selectedAssignedUser !== "") {
        params.set("assignedIds", selectedAssignedUser);
      }

      if (selectedLabel && selectedLabel !== "") {
        params.set("labelId", selectedLabel);
      }

      // Date filters
      if (filters.filingDateFrom)
        params.set("filingDateFrom", filters.filingDateFrom);
      if (filters.filingDateTo)
        params.set("filingDateTo", filters.filingDateTo);
      if (filters.registrationDateFrom)
        params.set("registrationDateFrom", filters.registrationDateFrom);
      if (filters.registrationDateTo)
        params.set("registrationDateTo", filters.registrationDateTo);
      if (filters.firstHearingDateFrom)
        params.set("firstHearingDateFrom", filters.firstHearingDateFrom);
      if (filters.firstHearingDateTo)
        params.set("firstHearingDateTo", filters.firstHearingDateTo);
      if (filters.decisionDateFrom)
        params.set("decisionDateFrom", filters.decisionDateFrom);
      if (filters.decisionDateTo)
        params.set("decisionDateTo", filters.decisionDateTo);

      return params.toString();
    },
    [filters, selectedAssignedUser, selectedLabel] // Add selectedAssignedUser and selectedLabel to dependencies
  );

  // Case limit data is now managed by CaseLimitContext
  // No need for local useEffect

  useEffect(() => {
    const fetchCases = async () => {
      try {
        setIsLoading(true); // Start loading

        const params = new URLSearchParams();
        // Use pagination state from context - only add if limit is not "all"
        if (pagination.limit !== "all") {
          params.set("page", pagination.page.toString());
          params.set("limit", pagination.limit.toString());
        }

        // if (searchInput && searchInput.trim()) {
        //   params.set("search", searchInput.trim());
        // }
        if (caseSearchTerm && caseSearchTerm.trim()) {
          params.set("search", caseSearchTerm.trim());
        }

        // if (selectedCaseCard) {
        //   params.set("onClick", selectedCaseCard);
        // }
        // Only add the onClick parameter if a specific filter card (not 'total') is selected.
        if (selectedCaseCard && selectedCaseCard !== "total") {
          params.set("onClick", selectedCaseCard);
        }

        if (filters && Object.keys(filters).length > 0) {
          Object.entries(filters).forEach(([key, value]) => {
            if (value && value.trim() && value !== "all") {
              params.set(key, value.trim());
            }
          });
        }

        if (selectedAssignedUser && selectedAssignedUser !== "") {
          params.set("assignedIds", selectedAssignedUser);
        }

        if (selectedLabel && selectedLabel !== "") {
          params.set("labelId", selectedLabel);
        }

        const queryString = params.toString();
        let response;

        if (role === "customer") {
          if (selectedCourtType === "HighCourt") {
            response = await getHighCourtCustomerCases(
              queryString ? `?${queryString}` : ""
            );
          } else if (selectedCourtType === "DistrictCourt") {
            response = await getDistrictCourtCustomerCases(
              queryString ? `?${queryString}` : ""
            );
          } else if (selectedCourtType === "OtherCourt") {
            response = await getOtherCourtCustomerCases(
              queryString ? `?${queryString}` : ""
            );
          } else if (selectedCourtType === "SupremeCourt") {
            response = await getSupremeCourtCustomerCases(
              queryString ? `?${queryString}` : ""
            );
          }
        } else {
          if (selectedCourtType === "OtherCourt") {
            response = await getIsCheckedOtherCourtCasesAddedManually(
              queryString ? `?${queryString}` : ""
            );
          } else if (
            selectedCourtType === "HighCourt" &&
            selectedCaseType === "fetched"
          ) {
            response = await getIsCheckedHighCourtCasesByCompany(
              queryString ? `?${queryString}` : ""
            );
          } else if (
            selectedCourtType === "HighCourt" &&
            selectedCaseType === "added"
          ) {
            response = await getIsCheckedHighCourtCasesAddedManually(
              queryString ? `?${queryString}` : ""
            );
          } else if (
            selectedCourtType === "DistrictCourt" &&
            selectedCaseType === "fetched"
          ) {
            response = await getIsCheckedDistrictCourtCasesByCompany(
              queryString ? `?${queryString}` : ""
            );
          } else if (
            selectedCourtType === "DistrictCourt" &&
            selectedCaseType === "added"
          ) {
            response = await getIsCheckedDistrictCourtCasesAddedManually(
              queryString ? `?${queryString}` : ""
            );
          } else if (
            selectedCourtType === "SupremeCourt" &&
            selectedCaseType === "fetched"
          ) {
            response = await getIsCheckedSupremeCourtCasesByCompany(
              queryString ? `?${queryString}` : ""
            );
          } else if (
            selectedCourtType === "SupremeCourt" &&
            selectedCaseType === "added"
          ) {
            response = await getIsCheckedSupremeCourtCasesAddedManually(
              queryString ? `?${queryString}` : ""
            );
          }
        }

        const caseData = response?.data || {};
        setDetailSecData(caseData);
        setFilteredCases(caseData.cases || []);
        setTotalFilteredCount(
          caseData.totalFilteredCases !== undefined
            ? caseData.totalFilteredCases
            : caseData.totalCases || 0
        );

        updateCasePaginationInfo(
          caseData.totalFilteredCases !== undefined
            ? caseData.totalFilteredCases
            : caseData.totalCases || 0,
          pagination.limit === "all"
            ? false
            : (caseData.cases || []).length === pagination.limit
        );

        // const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveSearch = caseSearchTerm && caseSearchTerm.trim();
        const hasActiveFilters =
          selectedCaseCard ||
          selectedAssignedUser !== "" ||
          (filters &&
            Object.values(filters).some(
              (val) => val && val.trim() && val !== "all"
            ));

        if (hasActiveSearch || hasActiveFilters) {
          // The search results will also be paginated now
          setSearchResults(caseData.cases || []);
          setSearchType("cases");
          setSearchMetadata({
            selectedCaseCard,
            selectedCourtType,
            selectedCaseType,
            filters,
            selectedAssignedUser,
            searchTerm: caseSearchTerm,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching cases:", err);
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
        setFilteredCases([]);
        updateCasePaginationInfo(0, false); // Reset pagination on error
        setIsLoading(false); // Stop loading on error
      }
    };

    if (activeTab === "Cases") {
      fetchCases();
    }
  }, [
    selectedCaseCard,
    selectedCourtType,
    selectedCaseType,
    // searchInput,
    caseSearchTerm,
    filters,
    selectedAssignedUser,
    selectedLabel,
    activeTab,
    role,
    setFilteredCases,
    setIsLoading,
    caseRefreshKey,
    pagination.page, // Add dependency on page number
    pagination.limit, // Add dependency on page size
    updateCasePaginationInfo, // Add dependency on update function
  ]);

  const handleInvoiceExport = async () => {
    try {
      const res =
        role === "customer"
          ? await getInvoicesCustomer()
          : await getInvoicesCompany();

      let invoices = res.data.invoice || [];

      if (selectedStatus !== "all") {
        invoices = invoices.filter((inv) => inv.status === selectedStatus);
      }

      if (selectedDateRange !== "all") {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();

        invoices = invoices.filter((inv) => {
          const invoiceDate = new Date(inv.createdAt);
          const invoiceYear = invoiceDate.getFullYear();
          const invoiceMonth = invoiceDate.getMonth();

          switch (selectedDateRange) {
            case "current-month":
              return (
                invoiceYear === currentYear && invoiceMonth === currentMonth
              );

            case "last-month":
              const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1;
              const lastMonthYear =
                currentMonth === 0 ? currentYear - 1 : currentYear;
              return (
                invoiceYear === lastMonthYear && invoiceMonth === lastMonth
              );

            case "june-2025":
              return invoiceYear === 2025 && invoiceMonth === 5;

            case "may-2025":
              return invoiceYear === 2025 && invoiceMonth === 4;

            case "april-2025":
              return invoiceYear === 2025 && invoiceMonth === 3;

            case "march-2025":
              return invoiceYear === 2025 && invoiceMonth === 2;

            case "select-range":
              if (startDate && endDate) {
                const start = new Date(startDate);
                const end = new Date(endDate);
                return invoiceDate >= start && invoiceDate <= end;
              }
              return true;

            case "previous-fy":
              const currentFYStartYear =
                currentMonth >= 3 ? currentYear : currentYear - 1;
              const previousFYStartYear = currentFYStartYear - 1;
              const previousFYEndYear = currentFYStartYear;

              return (
                (invoiceYear === previousFYStartYear && invoiceMonth >= 3) ||
                (invoiceYear === previousFYEndYear && invoiceMonth < 3)
              );

            case "select-range":
              return true;

            default:
              return true;
          }
        });
      }

      if (invoices.length === 0) {
        showToast("No invoices found for the selected filters", "warning");
        return;
      }

      await ExportInvoicetoExcel(
        invoices,
        `${selectedStatus}_${selectedDateRange}`
      );
      setIsInvoiceExportModalOpen(false);

      const statusText = selectedStatus === "all" ? "All" : selectedStatus;
      const dateRangeText =
        selectedDateRange === "all"
          ? "All dates"
          : selectedDateRange
            .replace("-", " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());

      showToast(
        `${invoices.length} invoices exported (${statusText} - ${dateRangeText})`,
        "success"
      );
    } catch (err) {
      console.error("Export failed:", err);
      showToast("Export failed. Please try again.", "error");
    }
  };

  const handleExportPDF = async (orientation) => {
    let casesToExport = [];

    if (searchResults.length > 0) {
      casesToExport = searchResults;
    } else if (filteredCases.length > 0) {
      casesToExport = filteredCases;
    } else {
      casesToExport = detailSecData.cases || [];
    }

    let freshSettings = global.globalSettings; // Fallback to context
    try {
      const res = await getAllGlobalSettingsData();
      if (res?.data) {
        freshSettings = res.data;
      }
    } catch (error) {
      console.error("Failed to fetch fresh global settings for PDF:", error);
    }

    // Pass freshSettings instead of global.globalSettings
    exportCasesToPDF(casesToExport, orientation, freshSettings);

    setIsPdfExportModalOpen(false);

    let exportMessage = `Cases exported to PDF in ${orientation} format`;
    if (searchResults.length > 0) {
      exportMessage = `${searchResults.length} search result cases exported to PDF in ${orientation} format`;
    } else if (filteredCases.length > 0) {
      exportMessage = `${filteredCases.length} filtered cases exported to PDF in ${orientation} format`;
    }

    showToast(exportMessage, "success");
  };

  const getMonthName = (monthIndex) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[monthIndex];
  };

  useEffect(() => {
    const fetchUserLimitData = async () => {
      try {
        setIsUserLimitLoading(true);
        const response = await getUserLimit();
        setUserLimitData(response.data);
      } catch (error) {
        console.error("Error fetching user limit on mount:", error);
        setUserLimitData(null);
      } finally {
        setIsUserLimitLoading(false);
      }
    };

    fetchUserLimitData();
  }, []);

  useEffect(() => {
    const fetchInvoiceData = async () => {
      if (activeTab !== "Invoices") return;

      try {
        setIsLoading(true);
        const response =
          role === "customer"
            ? await getInvoicesCustomer()
            : await getInvoicesCompany();

        const invoiceData = response?.data || {};
        setInvoiceData(invoiceData);
      } catch (err) {
        console.error("Error fetching invoice data:", err);
        setInvoiceData({});
      } finally {
        setIsLoading(false);
      }
    };

    fetchInvoiceData();
  }, [activeTab, role, invoiceRefreshKey]);

  useEffect(() => {
    window.setDetailSectionInvoiceData = (data) => {
      setInvoiceData(data);
    };

    return () => {
      delete window.setDetailSectionInvoiceData;
    };
  }, []);

  useEffect(() => {
    if (!selectedCourtType) {
      return;
    }

    if (
      role !== "customer" &&
      selectedCourtType !== "OtherCourt" &&
      !selectedCaseType
    ) {
      return;
    }

    const getMonthName = (monthIndex) => {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months[monthIndex];
    };

    const getAvailableMonths = (invoices) => {
      const monthSet = new Set();
      invoices.forEach((invoice) => {
        const date = new Date(invoice.createdAt);
        const monthYear = `${date.getFullYear()}-${date.getMonth()}`;
        monthSet.add(monthYear);
      });

      return Array.from(monthSet)
        .sort()
        .map((monthYear) => {
          const [year, month] = monthYear.split("-");
          return {
            value: monthYear,
            label: `${getMonthName(parseInt(month))} ${year}`,
          };
        });
    };

    const fetchDetailedCases = async () => {
      try {
        let response;
        const queryParams = "";


        if (role !== "customer") {
          if (selectedCourtType === "OtherCourt") {
            response = await getIsCheckedOtherCourtCasesAddedManually(
              `?${queryParams}`
            );
          } else if (selectedCourtType === "HighCourt") {
            if (selectedCaseType === "fetched") {
              response = await getIsCheckedHighCourtCasesByCompany(
                `?${queryParams}`
              );
            } else if (selectedCaseType === "added") {
              response = await getIsCheckedHighCourtCasesAddedManually(
                `?${queryParams}`
              );
            } else {
              showToast("Please select case type for High Court", "error");
              return;
            }
          } else if (selectedCourtType === "DistrictCourt") {
            if (selectedCaseType === "fetched") {
              response = await getIsCheckedDistrictCourtCasesByCompany(
                `?${queryParams}`
              );
            } else if (selectedCaseType === "added") {
              response = await getIsCheckedDistrictCourtCasesAddedManually(
                `?${queryParams}`
              );
            } else {
              showToast("Please select case type for District Court", "error");
              return;
            }
          } else {
            showToast("Invalid Court Type", "error");
            return;
          }
        } else {
          if (selectedCourtType === "HighCourt") {
            response = await getHighCourtCustomerCases();
          } else if (selectedCourtType === "DistrictCourt") {
            response = await getDistrictCourtCustomerCases();
          } else if (selectedCourtType === "OtherCourt") {
            response = await getOtherCourtCasesAddedManually();
          } else {
            showToast("Invalid Court Type", "warning");
            return;
          }
        }

        const detaildata = response?.data || [];
        setDetailSecData(detaildata);
      } catch (error) {
        console.error("Error fetching detailed cases:", error);
        setDetailSecData([]);
      }
    };
    // fetchDetailedCases(); // This fetch is now redundant due to the main fetchCases useEffect
  }, [
    username,
    selectedCaseType,
    selectedCourtType,
    role,
    filters,
    selectedAssignedUser,
  ]);

  useEffect(() => {
    if (activeTab === "Cases" && caseLimitData) {
      // Use the preloaded caseLimitData instead of fetching again
      setCompanyStats(caseLimitData);
    }
  }, [activeTab, caseLimitData]);

  // useEffect(() => {
  //   if (activeTab === "Cases") {
  //     const fetchCompanyStats = async () => {
  //       try {
  //         const response = await getCompanyLimitedStats();
  //         setCompanyStats(response?.data);
  //       } catch (error) {
  //         console.error("Error fetching company stats:", error);
  //       }
  //     };

  //     fetchCompanyStats();
  //   }
  // }, [activeTab]);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        let response;

        // Build query parameters that include search + filters + cards
        const params = new URLSearchParams();

        // Only add pagination parameters if limit is not "all"
        if (taskPagination?.limit !== "all") {
          params.set("page", taskPagination?.page?.toString() || "0");
          params.set("limit", taskPagination?.limit?.toString() || "20");
        }

        // Add search term if exists
        // if (searchInput && searchInput.trim()) {
        //   params.set("search", searchInput.trim());
        // }
        if (taskSearchTerm && taskSearchTerm.trim()) {
          params.set("search", taskSearchTerm.trim());
        }

        // Add card-based filtering
        if (selectedCard) {
          switch (selectedCard) {
            case "completed":
              params.set("isCompleted", "true");
              params.set("onClick", "completed");
              break;
            case "pending":
              params.set("isCompleted", "false");
              params.set("onClick", "pending");
              break;
            case "today":
              params.set("onClick", "today");
              break;
            case "total":
              params.set("onClick", "total");
              break;
          }
        }

        // Add filter parameters from TaskSelectionContext
        if (filters && Object.keys(filters).length > 0) {
          Object.entries(filters).forEach(([key, value]) => {
            // Filter out empty strings and "all" values
            if (value && value.trim() && value.trim() !== "all") {
              params.set(key, value.trim());
            }
          });
        }

        const queryString = params.toString();

        // Make API call
        if (taskTab === "assignedToMe") {
          response = await getTasksAssignedToUser(
            queryString ? `?${queryString}` : ""
          );
        } else if (taskTab === "assignedByMe") {
          response = await getTasksAssignedByUser(
            queryString ? `?${queryString}` : ""
          );
        }

        const taskdata = response?.data || {};

        setTaskSecData(taskdata);

        // Determine if we're in search/filter mode
        // const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveSearch = taskSearchTerm && taskSearchTerm.trim();
        const hasActiveFilters =
          selectedCard ||
          (filters && Object.values(filters).some((val) => val && val.trim()));



        if (hasActiveSearch || hasActiveFilters) {

          setSearchResults(taskdata.tasks || []);
          setSearchType("tasks");
          setSearchMetadata({
            taskTab,
            selectedCard,
            filters,
            searchTerm: taskSearchTerm,
            totalTasks: taskdata.tasks?.length || 0,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching tasks:", err);
        // Clear everything on error
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
      }
    };

    // Only run if we're on Tasks tab
    if (activeTab === "Tasks") {
      fetchTasks();
    }
  }, [
    taskTab,
    selectedCard,
    // searchInput,
    taskSearchTerm,
    filters,
    activeTab,
    taskPagination?.page,
    taskPagination?.limit,
    setSearchResults,
    setSearchType,
    setSearchMetadata,
    refreshKey,
  ]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        let response;

        // Build query parameters that include search + filters
        const params = new URLSearchParams();

        // Only add pagination parameters if limit is not "all"
        if (clientPagination.limit !== "all") {
          params.set("page", clientPagination.page.toString());
          params.set("limit", clientPagination.limit.toString());
        }

        // Add search term if exists
        // if (searchInput && searchInput.trim()) {
        //   params.set("search", searchInput.trim());
        // }
        if (clientSearchTerm && clientSearchTerm.trim()) {
          params.set("search", clientSearchTerm.trim());
        }

        // Add filter parameters from ClientSelectionContext
        if (clientFilters && Object.keys(clientFilters).length > 0) {
          Object.entries(clientFilters).forEach(([key, value]) => {
            if (value && value.trim() && value.trim() !== "all") {
              // Map context filter names to API parameter names
              const apiKey = key === "clientName" ? "name" : key;
              params.set(apiKey, value.trim());
            }
          });
        }

        const queryString = params.toString();

        // Make API call
        response = await getMyClients(queryString ? `?${queryString}` : "");

        const clientData = response?.data || {};


        setMyClientsData(clientData);

        // Update context with filtered results
        setFilteredClients(clientData.client || []);

        // if (clientData.total !== undefined) {
        //   updateClientPaginationInfo(
        //     clientData.total,
        //     clientData.total > (clientPagination.page + 1) * clientPagination.limit
        //   );
        // }

        if (clientData.clientCount !== undefined) {
          updateClientPaginationInfo(
            clientData.clientCount,
            clientPagination.limit === "all"
              ? false
              : clientData.clientCount >
              (clientPagination.page + 1) * clientPagination.limit
          );
        }

        // Determine if we're in search/filter mode
        // const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveSearch = clientSearchTerm && clientSearchTerm.trim();
        const hasActiveFilters =
          clientFilters &&
          Object.values(clientFilters).some((val) => val && val.trim());



        if (hasActiveSearch || hasActiveFilters) {

          setSearchResults(clientData.client || []);
          setSearchType("clients");
          setSearchMetadata({
            filters: clientFilters,
            searchTerm: clientSearchTerm,
            totalClients: clientData.client?.length || 0,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching clients:", err);
        // Clear everything on error
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
        updateClientPaginationInfo(0, false); // Reset pagination on error
      }
    };

    // Only run if we're on Add My Clients tab
    if (activeTab === "Add My Clients") {
      fetchClients();
    }
  }, [
    // searchInput,
    clientSearchTerm,
    clientFilters,
    activeTab,
    setFilteredClients,
    clientRefreshKey,
    clientPagination.page,
    clientPagination.limit,
    updateClientPaginationInfo,
  ]);

  useEffect(() => {
    const fetchLabels = async () => {
      try {
        let response;

        // Build query parameters that include search + filters
        const params = new URLSearchParams();
        // params.set("page", "0");
        // params.set("limit", "20");

        // params.set("page", labelPagination?.page?.toString()); // Use context pagination
        // params.set("limit", labelPagination?.limit?.toString());

        // Add search term if exists
        // if (searchInput && searchInput.trim()) {
        //   params.set("search", searchInput.trim());
        // }
        if (labelSearchTerm && labelSearchTerm.trim()) {
          params.set("search", labelSearchTerm.trim());
        }

        // Add filter parameters from LabelSelectionContext
        if (labelFilters && Object.keys(labelFilters).length > 0) {
          Object.entries(labelFilters).forEach(([key, value]) => {
            if (value && value.trim()) {
              params.set(key, value.trim());
            }
          });
        }

        const queryString = params.toString();
        // Make API call
        response = await getLabelsByUser(queryString ? `?${queryString}` : "");

        const labelData = response?.data || {};

        setLabelData(labelData);

        // Process the labels (flatten the structure like in original Labels component)
        const processedLabels = labelData.labels
          ? labelData.labels.flatMap((item) =>
            item.labels.map((label) => ({
              _id: label._id,
              name: label.name,
              color: label.color,
              description: label.description,
              priorityLevel: label.priorityLevel,
              createdAt: label.createdAt,
              branchId: label.branchId,
              courtRef: label.courtRef,
              user: label.user,
              labeldata: label,
            }))
          )
          : [];

        // Update context with filtered results
        setFilteredLabels(processedLabels);
        if (labelData.total !== undefined) {
          updateLabelPaginationInfo(
            labelData.total,
            labelData.total >
            (labelPagination?.page + 1) * labelPagination?.limit
          );
        }

        // Determine if we're in search/filter mode
        //const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveSearch = labelSearchTerm && labelSearchTerm.trim();
        const hasActiveFilters =
          labelFilters &&
          Object.values(labelFilters).some((val) => val && val.trim());


        if (hasActiveSearch || hasActiveFilters) {
          setSearchResults(processedLabels);
          setSearchType("labels");
          setSearchMetadata({
            filters: labelFilters,
            searchTerm: labelSearchTerm,
            totalLabels: processedLabels.length,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching labels:", err);
        // Clear everything on error
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
        updateLabelPaginationInfo(0, false); // Reset pagination on error
      }
    };

    // Only run if we're on Labels tab
    if (activeTab === "Labels") {
      fetchLabels();
    }
  }, [
    // searchInput,
    labelSearchTerm,
    labelFilters,
    activeTab,
    setFilteredLabels,
    labelRefreshKey,
    labelPagination?.page, // Add pagination dependencies
    labelPagination?.limit,
    updateLabelPaginationInfo,
  ]);

  useEffect(() => {
    const fetchBranchDetails = async () => {
      try {
        const response = await getallBranchNames(companyID);
        const branchdata = response?.data;
        setBranchData(branchdata);
      } catch (err) {
        console.error("Error fetching my branches:", err);
      }
    };
    fetchBranchDetails();
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        let response;

        // Build query parameters that include search + filters + cards
        const params = new URLSearchParams();

        // Only add pagination params if not "all"
        if (userPagination.limit !== "all") {
          params.set("page", userPagination.page.toString());
          params.set("limit", userPagination.limit.toString());
        }

        // Add search term if exists
        // if (searchInput && searchInput.trim()) {
        //   params.set("search", searchInput.trim());
        // }
        if (userSearchTerm && userSearchTerm.trim()) {
          params.set("search", userSearchTerm.trim());
        }

        if (selectedUserCard && selectedUserCard !== "all") {
          // Map card types to API parameters correctly
          if (selectedUserCard === "active") {
            params.set("status", "active");
          } else if (selectedUserCard === "inactive") {
            params.set("status", "inActive");
            params.set("onClick", "inActive");
          } else if (selectedUserCard === "total") {
            // Don't set isActive for total - show all users
            params.set("onClick", selectedUserCard);
          }
        }

        if (userFilters && Object.keys(userFilters).length > 0) {
          Object.entries(userFilters).forEach(([key, value]) => {
            if (value && value.trim() && value.trim() !== "all") {
              if (key === "status") {
                if (value === "active") {
                  params.set("status", "active");
                } else if (value === "inactive") {
                  params.set("status", "inActive");
                }
              } else {
                params.set(key, value.trim());
              }
            }
          });
        }

        const queryString = params.toString();

        // Make API call
        response = await getHierarchy(queryString ? `?${queryString}` : "");

        const userData = response?.data || {};

        setAddUserData(userData);

        // Update context with filtered results
        setFilteredUsers(userData.users || []);
        if (userData.totalUsers !== undefined) {
          updateUserPaginationInfo(
            userData.totalUsers,
            userPagination.limit === "all"
              ? false
              : userData.totalUsers >
              (userPagination.page + 1) * userPagination.limit
          );
        }

        // Determine if we're in search/filter mode
        // const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveSearch = userSearchTerm && userSearchTerm.trim();
        const hasActiveFilters =
          selectedUserCard ||
          (userFilters &&
            Object.values(userFilters).some((val) => val && val.trim()));



        if (hasActiveSearch || hasActiveFilters) {

          setSearchResults(userData.users || []);
          setSearchType("addusers");
          setSearchMetadata({
            selectedCard: selectedUserCard,
            filters: userFilters,
            searchTerm: userSearchTerm,
            totalUsers: userData.users?.length || 0,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching users:", err);
        // Clear everything on error
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
        setFilteredUsers([]);
        updateUserPaginationInfo(0, false); // Reset pagination on error
      }
    };

    // Only run if we're on Manage Users tab
    if (activeTab === "Manage Users") {

      fetchUsers();
    }
  }, [
    selectedUserCard,
    // searchInput,
    userSearchTerm,
    userFilters,
    activeTab,
    setFilteredUsers,
    userRefreshKey,
    userPagination.page,
    userPagination.limit,
    updateUserPaginationInfo,
  ]);


  useEffect(() => {
    const fetchNotes = async () => {
      try {
        let response;

        // Build query parameters that include search + filters
        const params = new URLSearchParams();

        // Only add pagination params if not "all"
        if (notePagination.limit !== "all") {
          params.set("page", notePagination.page.toString());
          params.set("limit", notePagination.limit.toString());
        }

        // Add search term if exists
        // if (searchInput && searchInput.trim()) {
        //   params.set("search", searchInput.trim());
        // }
        if (noteSearchTerm && noteSearchTerm.trim()) {
          params.set("search", noteSearchTerm.trim());
        }

        // Add filter parameters from NoteSelectionContext and exclude "all" values
        if (noteFilters && Object.keys(noteFilters).length > 0) {
          Object.entries(noteFilters).forEach(([key, value]) => {
            if (value && value.trim() && value.trim() !== "all") {
              params.set(key, value.trim());
            }
          });
        }

        const queryString = params.toString();

        // Make API call
        response = await getNoteByUser(queryString ? `?${queryString}` : "");

        const noteData = response?.data || {};


        setNotesData(noteData);

        // Update context with filtered results
        setFilteredNotes(noteData.notes || []);

        if (response.data.total !== undefined) {
          updateNotePaginationInfo(
            response.data.total,
            notePagination.limit === "all"
              ? false
              : response.data.total >
              (notePagination.page + 1) * notePagination.limit
          );
        }

        // Determine if we're in search/filter mode
        // const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveSearch = noteSearchTerm && noteSearchTerm.trim();
        const hasActiveFilters =
          noteFilters &&
          Object.values(noteFilters).some((val) => val && val.trim());



        if (hasActiveSearch || hasActiveFilters) {

          setSearchResults(noteData.notes || []);
          setSearchType("notes");
          setSearchMetadata({
            filters: noteFilters,
            searchTerm: noteSearchTerm,
            totalNotes: noteData.notes?.length || 0,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching notes:", err);
        // Clear everything on error
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
        updateNotePaginationInfo(0, false);
      }
    };

    // Only run if we're on Notes tab
    if (activeTab === "Notes") {

      fetchNotes();
    }
  }, [
    // searchInput,
    noteSearchTerm,
    noteFilters,
    activeTab,
    setFilteredNotes,
    noteRefreshKey,
    notePagination?.page,
    notePagination?.limit,
    updateNotePaginationInfo,
  ]);

  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        let response;

        // Build query parameters that include search + filters
        const params = new URLSearchParams();

        // Only add pagination params if not "all"
        if (expensePagination.limit !== "all") {
          params.set("page", expensePagination.page.toString());
          params.set("limit", expensePagination.limit.toString());
        }

        // Add search term if exists
        // if (searchInput && searchInput.trim()) {
        //   params.set("search", searchInput.trim());

        // }
        if (expenseSearchTerm && expenseSearchTerm.trim()) {
          params.set("search", expenseSearchTerm.trim());
        }

        // FIXED: Add filter parameters with proper empty string checking and exclude "all" values
        if (expenseFilters && Object.keys(expenseFilters).length > 0) {
          Object.entries(expenseFilters).forEach(([key, value]) => {
            // IMPORTANT: Check for both truthy value AND non-empty string after trimming, and exclude "all"
            if (
              value &&
              typeof value === "string" &&
              value.trim() !== "" &&
              value.trim() !== "all"
            ) {
              // Map frontend filter names to API parameter names
              let apiKey = key;
              if (key === "type") apiKey = "expenseType";

              params.set(apiKey, value.trim());
            }
          });
        }

        const queryString = params.toString();

        // Make API call
        response = await getExpenseByUser(queryString ? `?${queryString}` : "");

        const expenseData = response?.data || {};


        setExpenseData(expenseData);
        setFilteredExpenses(expenseData.expenses || []);

        if (expenseData.expenseCount !== undefined) {
          updateExpensePaginationInfo(
            expenseData.expenseCount,
            expensePagination.limit === "all"
              ? false
              : expenseData.expenseCount >
              (expenseData.page + 1) * expenseData.limit
          );
        }

        // Determine if we're in search/filter mode
        // const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveSearch = expenseSearchTerm && expenseSearchTerm.trim();
        const hasActiveFilters =
          expenseFilters &&
          Object.values(expenseFilters).some(
            (val) => val && typeof val === "string" && val.trim() !== ""
          );



        if (hasActiveSearch || hasActiveFilters) {
          setSearchResults(expenseData.expenses || []);
          setSearchType("expenses");
          setSearchMetadata({
            filters: expenseFilters,
            searchTerm: expenseSearchTerm,
            totalExpenses: expenseData.expenses?.length || 0,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching expenses:", err);
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
      }
    };

    if (activeTab === "Expenses") {
      fetchExpenses();
    }
  }, [
    // searchInput,
    expenseSearchTerm,
    expenseFilters,
    activeTab,
    setFilteredExpenses,
    updateExpensePaginationInfo,
    expenseRefreshKey,
  ]);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        let response;
        setIsLoading(true);

        // Build query parameters that include search + filters + cards
        const params = new URLSearchParams();

        // Only add pagination params if not "all"
        if (invoicePagination.limit !== "all") {
          params.set("page", invoicePagination.page.toString());
          params.set("limit", invoicePagination.limit.toString());
        }

        // Add search term if exists
        // if (searchInput && searchInput.trim()) {
        //   params.set("search", searchInput.trim());
        // }
        if (invoiceSearchTerm && invoiceSearchTerm.trim()) {
          params.set("search", invoiceSearchTerm.trim());
        }

        // Add card-based filtering and exclude "all"
        if (selectedInvoiceCard && selectedInvoiceCard !== "all") {
          params.set("onClick", selectedInvoiceCard);
        }

        // Map frontend filter keys to backend parameter names
        const filterKeyMap = {
          minAmount: 'minTotal',
          maxAmount: 'maxTotal'
        };

        // Add filter parameters from InvoiceSelectionContext with proper empty string checking and exclude "all" values
        if (invoiceFilters && Object.keys(invoiceFilters).length > 0) {
          Object.entries(invoiceFilters).forEach(([key, value]) => {
            // IMPORTANT: Check for both truthy value AND non-empty string after trimming, and exclude "all"
            if (
              value &&
              typeof value === "string" &&
              value.trim() !== "" &&
              value.trim() !== "all"
            ) {
              const backendKey = filterKeyMap[key] || key;
              params.set(backendKey, value.trim());
            }
          });
        }

        const queryString = params.toString();

        // Make API call
        response =
          role === "customer"
            ? await getInvoicesCustomer(queryString ? `?${queryString}` : "")
            : await getInvoicesCompany(queryString ? `?${queryString}` : "");

        const invoiceData = response?.data || {};

        // ALWAYS SET THE INVOICE DATA FOR STATS - THIS WAS MISSING
        setInvoiceData(invoiceData);

        // Update context with filtered results
        setFilteredInvoices(invoiceData.invoice || []);

        // Update pagination info if available
        updateInvoicePaginationInfo(
          invoiceData.total || 0,
          invoicePagination.limit === "all"
            ? false
            : (invoiceData.invoice || []).length === invoicePagination.limit
        );

        // Determine if we're in search/filter mode
        // const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveSearch = invoiceSearchTerm && invoiceSearchTerm.trim();
        const hasActiveFilters =
          selectedInvoiceCard ||
          (invoiceFilters &&
            Object.values(invoiceFilters).some(
              (val) => val && typeof val === "string" && val.trim() !== ""
            ));


        if (hasActiveSearch || hasActiveFilters) {
          setSearchResults(invoiceData.invoice || []);
          setSearchType("invoices");
          setSearchMetadata({
            selectedCard: selectedInvoiceCard,
            filters: invoiceFilters,
            searchTerm: invoiceSearchTerm,
            totalInvoices: invoiceData.invoice?.length || 0,
            isUnified: true,
            role,
          });
          setHasPerformedSearch(true);
        } else {
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching invoices:", err);
        // Clear everything on error
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
        setFilteredInvoices([]);
        setInvoiceData({});
        updateInvoicePaginationInfo(0, false);
      } finally {
        setIsLoading(false);
      }
    };

    // IMPORTANT: Always run when on Invoices tab to ensure fresh data on clear
    if (activeTab === "Invoices") {
      fetchInvoices();
    }
  }, [
    activeTab,
    role,
    invoicePagination.page,
    invoicePagination.limit,
    selectedInvoiceCard,
    // searchInput, 
    invoiceSearchTerm,
    invoiceFilters,
    invoiceRefreshKey,
    setFilteredInvoices,
    updateInvoicePaginationInfo,
    setIsLoading,
    //buildInvoiceQueryParams
  ]);

  const performSearch = async (searchTerm) => {
    try {
      if (!searchTerm.trim()) {
        setSearchResults([]);
        setsearchDetailSecData({});
        setSearchType("");
        setSearchMetadata({});
        setHasPerformedSearch(false);
        localStorage.setItem("hasSearched", "false");
        setSearchInput("");
        return;
      }

      let response;

      switch (activeTab) {
        case "Cases":
          if (!selectedCourtType) {
            showToast("Please select court type", "error");
            return;
          }

          const queryParams = buildQueryParams(searchTerm);

          // Handle OtherCourt search
          if (selectedCourtType === "OtherCourt") {
            try {
              const otherCourtResponse =
                await getIsCheckedOtherCourtCasesAddedManually(
                  `?${queryParams}`
                );
              setSearchResults(otherCourtResponse?.data?.cases || []);
              setsearchDetailSecData(otherCourtResponse?.data || {});
              setSearchType("cases");
              setSearchMetadata(otherCourtResponse?.data || {});
            } catch (error) {
              console.error("Error searching OtherCourt cases:", error);
              setSearchResults([]);
            }
            break;
          }

          // For High Court and District Court
          if (!selectedCaseType) {
            showToast("Please select case type", "error");
            return;
          }

          if (
            selectedCourtType === "HighCourt" &&
            selectedCaseType === "fetched"
          ) {
            response = await getIsCheckedHighCourtCasesByCompany(
              `?${queryParams}`
            );
          } else if (
            selectedCourtType === "HighCourt" &&
            selectedCaseType === "added"
          ) {
            response = await getIsCheckedHighCourtCasesAddedManually(
              `?${queryParams}`
            );
          } else if (
            selectedCourtType === "DistrictCourt" &&
            selectedCaseType === "fetched"
          ) {
            response = await getIsCheckedDistrictCourtCasesByCompany(
              `?${queryParams}`
            );
          } else if (
            selectedCourtType === "DistrictCourt" &&
            selectedCaseType === "added"
          ) {
            response = await getIsCheckedDistrictCourtCasesAddedManually(
              `?${queryParams}`
            );
          }

          setSearchResults(response?.data?.cases || []);
          setsearchDetailSecData(response?.data || {});
          setSearchType("cases");
          setSearchMetadata(response?.data || {});
          break;

        // case "Tasks":
        //   const taskParams = new URLSearchParams();
        //   taskParams.set('search', searchTerm);

        //   // Add card-based filtering to search
        //   if (selectedCard) {
        //     switch (selectedCard) {
        //       case 'completed':
        //         taskParams.set('isCompleted', 'true');
        //         taskParams.set('onClick', 'completed');
        //         break;
        //       case 'pending':
        //         taskParams.set('isCompleted', 'false');
        //         taskParams.set('onClick', 'pending');
        //         break;
        //       case 'today':
        //         taskParams.set('onClick', 'today');
        //         break;
        //       case 'total':
        //         taskParams.set('onClick', 'total');
        //         break;
        //     }
        //   }

        //   const taskQueryString = taskParams.toString();

        //   if (taskTab === "assignedToMe") {
        //     response = await getTasksAssignedToUser(`?${taskQueryString}`);
        //   } else if (taskTab === "assignedByMe") {
        //     response = await getTasksAssignedByUser(`?${taskQueryString}`);
        //   }

        //   setSearchResults(response?.data?.tasks || response?.data || []);
        //   setTaskSecData(response?.data);
        //   setSearchType("tasks");
        //   setSearchMetadata({
        //     taskTab,
        //     selectedCard,
        //     totalTasks: response?.data?.tasks?.length || 0,
        //   });
        //   break;

        case "Notes":
          response = await searchNote(searchTerm);
          setSearchResults(response?.data?.notes || response?.data || []);
          setNotesData(response?.data);
          setSearchType("notes");
          setSearchMetadata({ totalNotes: response?.data?.notes?.length || 0 });
          break;

        case "Expenses":
          response = await searchExpenses(searchTerm);
          setSearchResults(response?.data?.expenses || response?.data || []);
          setExpenseData(response?.data);
          setSearchType("expenses");
          setSearchMetadata({
            totalExpenses: response?.data?.expenses?.length || 0,
          });
          break;

        case "Labels":
          response = await searchLabel(searchTerm);

          let labelsData = [];
          if (response?.data?.labels) {
            labelsData = response.data.labels;
          } else if (response?.data && Array.isArray(response.data)) {
            labelsData = response.data;
          } else if (response?.labels) {
            labelsData = response.labels;
          }

          setSearchResults(labelsData);
          setLabelData(response?.data);
          setSearchType("labels");
          setSearchMetadata({ totalLabels: labelsData.length || 0 });
          break;

        case "Add My Clients":
          response = await searchMyClient(searchTerm);
          setSearchResults(response?.data?.clients || response?.data || []);
          setMyClientsData(response?.data);
          setSearchType("clients");
          setSearchMetadata({
            totalClients: response?.data?.clients?.length || 0,
          });
          break;

        case "Invoices":
          if (role === "customer") {
            response = await InvoiceForClient(searchTerm);
          } else {
            response = await InvoiceForCompany(searchTerm);
          }
          setSearchResults(response?.data?.invoices || response?.data || []);
          setInvoiceData(response?.data);
          setSearchType("invoices");
          setSearchMetadata({
            role,
            totalInvoices: response?.data?.invoices?.length || 0,
          });
          break;

        case "Manage Users":
          response = await searchAddedUsers(searchTerm);
          const users = response?.data?.users || [];


          const filteredUsers = users.filter(
            (user) =>
              user?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
              user?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
              user?.phno?.includes(searchTerm)
          );

          setSearchResults(filteredUsers);
          setAddUserData(response?.data);
          setSearchType("addusers");
          setSearchMetadata({ totalUsers: filteredUsers.length });
          break;

        default:
          return;
      }

      setHasPerformedSearch(true);
      localStorage.setItem("hasSearched", "true");
    } catch (error) {
      console.error(`Error searching ${activeTab}:`, error);
      setSearchResults([]);
      setSearchType("");
      setSearchMetadata({});
    }
  };

  const hasActiveFilters = useMemo(() => {
    // For Cases tab, check search input, card selection, and filters
    if (activeTab === "Cases") {
      return (
        // (searchInput && searchInput.trim()) ||
        (caseSearchTerm && caseSearchTerm.trim()) || // Check Context
        selectedCaseCard !== null ||
        selectedAssignedUser !== "" ||
        selectedLabel !== "" ||
        (filters &&
          Object.values(filters).some(
            (val) => val && val.trim() && val !== "all"
          ))
      );
    }

    // For tasks, check search input and filters
    if (activeTab === "Tasks") {
      return (
        // (searchInput && searchInput.trim()) ||
        (taskSearchTerm && taskSearchTerm.trim()) ||
        selectedCard !== null ||
        (filters &&
          Object.values(filters).some((val) => val && val.trim() !== ""))
      );
    }

    // For invoices, check search input and filters
    if (activeTab === "Invoices") {
      return (
        // (searchInput && searchInput.trim()) ||
        (invoiceSearchTerm && invoiceSearchTerm.trim()) ||
        selectedInvoiceCard !== null ||
        (invoiceFilters &&
          Object.values(invoiceFilters).some((val) => val && val.trim() !== ""))
      );
    }

    // For clients, check search input and filters
    if (activeTab === "Add My Clients") {
      return (
        // (searchInput && searchInput.trim()) ||
        (clientSearchTerm && clientSearchTerm.trim()) ||
        (clientFilters &&
          Object.values(clientFilters).some((val) => val && val.trim() !== ""))
      );
    }

    // For labels, check search input and filters
    if (activeTab === "Labels") {
      return (
        // (searchInput && searchInput.trim()) ||
        (labelSearchTerm && labelSearchTerm.trim()) ||
        (labelFilters &&
          Object.values(labelFilters).some((val) => val && val.trim() !== ""))
      );
    }

    // For notes, check search input and filters
    if (activeTab === "Notes") {
      return (
        // (searchInput && searchInput.trim()) ||
        (noteSearchTerm && noteSearchTerm.trim()) ||
        (noteFilters &&
          Object.values(noteFilters).some((val) => val && val.trim() !== ""))
      );
    }

    // For expenses, check search input and filters
    if (activeTab === "Expenses") {
      return (
        // (searchInput && searchInput.trim()) ||
        (expenseSearchTerm && expenseSearchTerm.trim()) ||
        (expenseFilters &&
          Object.values(expenseFilters).some((val) => val && val.trim() !== ""))
      );
    }

    if (activeTab === "Manage Users") {
      // const hasSearchInput = searchInput && searchInput.trim();
      const hasSearchInput = userSearchTerm && userSearchTerm.trim();
      const hasCardSelection = selectedUserCard !== null;
      const hasFilterValues =
        userFilters &&
        Object.values(userFilters).some((val) => val && val.trim() !== "");

      return hasSearchInput || hasCardSelection || hasFilterValues;
    }

    // For other tabs, keep existing logic
    return (
      (searchType === "cases" && searchResults.length > 0) ||
      selectedAssignedUser !== "" ||
      Object.values(filters || {}).some(
        (val) => val && val !== "all" && val !== ""
      )
    );
  }, [
    filters,
    selectedAssignedUser,
    selectedCaseCard,
    selectedLabel,
    searchType,
    searchResults,
    selectedCard,
    selectedInvoiceCard,
    invoiceFilters,
    labelFilters,
    noteFilters,
    expenseFilters,
    userFilters,
    selectedUserCard,
    clientFilters,
    searchInput,
    activeTab,
    caseSearchTerm,
    taskSearchTerm,
    invoiceSearchTerm,
    clientSearchTerm,
    labelSearchTerm,
    noteSearchTerm,
    expenseSearchTerm,
    userSearchTerm,
  ]);

  useEffect(() => {
    if (searchType === "" && searchResults.length === 0) {
      console.log("Search completely cleared - ensuring display cases reset");
    }
  }, [searchType, searchResults]);

  const triggerSearch = useCallback(() => {
    const trimmedInput = searchInput.trim();

    // 1. Trigger for Cases (Context based)
    if (activeTab === "Cases") {
      setCaseSearchTerm(trimmedInput);
    }
    if (activeTab === "Tasks") setTaskSearchTerm(trimmedInput);
    if (activeTab === "Invoices") setInvoiceSearchTerm(trimmedInput);
    if (activeTab === "Expenses") setExpenseSearchTerm(trimmedInput);
    if (activeTab === "Notes") setNoteSearchTerm(trimmedInput);
    if (activeTab === "Manage Users") setUserSearchTerm(trimmedInput);
    if (activeTab === "Add My Clients") setClientSearchTerm(trimmedInput);

  }, [
    searchInput,
    activeTab,
    setCaseSearchTerm,
    setTaskSearchTerm,
    setInvoiceSearchTerm,
    setExpenseSearchTerm,
    setNoteSearchTerm,
    setUserSearchTerm,
    setClientSearchTerm

  ]);


  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //     const trimmedInput = searchInput.trim();

  //     // 1. Sync Input to Context (Preservation Logic)
  //     if (activeTab === "Cases") setCaseSearchTerm(trimmedInput);
  //     if (activeTab === "Tasks") setTaskSearchTerm(trimmedInput); // Updated alias
  //     if (activeTab === "Invoices") setInvoiceSearchTerm(trimmedInput);
  //     if (activeTab === "Labels") setLabelSearchTerm(trimmedInput);
  //     if (activeTab === "Notes") setNoteSearchTerm(trimmedInput);
  //     if (activeTab === "Expenses") setExpenseSearchTerm(trimmedInput);
  //     if (activeTab === "Manage Users") setUserSearchTerm(trimmedInput);
  //     if (activeTab === "Add My Clients") setClientSearchTerm(trimmedInput);

  //     // 2. Perform Search / Clear Logic
  //     if (trimmedInput === "") {
  //       setSearchResults([]);
  //       setsearchDetailSecData({});
  //       setSearchType("");
  //       setSearchMetadata({});
  //       setHasPerformedSearch(false);
  //       localStorage.setItem("hasSearched", "false");
  //       return;
  //     }

  //     // 3. Trigger API Search (Existing Logic)
  //     // Skip API triggers here for tabs that use Context-based filtering (Tasks, Labels, etc)
  //     // because the setters above (Step 1) already trigger the API calls inside their respective Contexts/Components.

  //     const contextHandledTabs = ["Tasks", "Labels", "Notes", "Expenses", "Manage Users", "Add My Clients", "Invoices"];

  //     if (contextHandledTabs.includes(activeTab)) {
  //       return; 
  //     }

  //     // Only perform manual search trigger for Cases (or others not fully context-driven)
  //     if (activeTab === "Cases" && !username) return;

  //     showLoading();
  //     performSearch(trimmedInput).finally(() => hideLoading());

  //   }, 500);

  //   return () => clearTimeout(delayDebounce);
  // }, [
  //   searchInput,
  //   activeTab,
  //   // Add all setters to dependency array
  //   setCaseSearchTerm,
  //   setTaskSearchTerm,
  //   setInvoiceSearchTerm,
  //   setLabelSearchTerm,
  //   setNoteSearchTerm,
  //   setExpenseSearchTerm,
  //   setUserSearchTerm,
  //   setClientSearchTerm,
  //   // specific dependencies
  //   username,
  //   role,
  //   selectedCourtType,
  //   selectedCaseType,
  //   companyID
  // ]);


  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const trimmedInput = searchInput.trim();
      const currentTab = activeTabRef.current; // Use the Ref value

      // 1. Handle Empty Input (Clear / Reset)
      if (trimmedInput === "") {
        setSearchResults([]);
        setsearchDetailSecData({});
        setSearchType("");
        setSearchMetadata({});
        setHasPerformedSearch(false);
        localStorage.setItem("hasSearched", "false");

        // Clear Contexts using the Ref to ensure we target the correct tab
        if (currentTab === "Cases") setCaseSearchTerm("");

        // Clear others
        if (currentTab === "Tasks") setTaskSearchTerm("");
        if (currentTab === "Invoices") setInvoiceSearchTerm("");
        if (currentTab === "Labels") setLabelSearchTerm("");
        if (currentTab === "Notes") setNoteSearchTerm("");
        if (currentTab === "Expenses") setExpenseSearchTerm("");
        if (currentTab === "Manage Users") setUserSearchTerm("");
        if (currentTab === "Add My Clients") setClientSearchTerm("");

        return;
      }

      // 2. Sync Input to Context (Auto-Search Logic)
      // EXCLUDE "Cases" from auto-sync (Manual trigger only)
      const manualTabs = [
        "Cases",
        "Tasks",
        "Invoices",
        "Expenses",
        "Notes",
        "Manage Users",
        "Add My Clients"
      ];

      // 3. Perform Search for tabs NOT handled by Context
      if (!manualTabs.includes(currentTab)) {
        if (currentTab === "Labels") setLabelSearchTerm(trimmedInput);
      }

      // 3. Perform Search for tabs NOT handled by Context (Legacy)
      // (Ensure we don't double fetch for manual tabs)
      const contextHandledTabs = [...manualTabs, "Labels"];

      if (contextHandledTabs.includes(currentTab)) {
        return;
      }

      if (!username) return;
      showLoading();
      performSearch(trimmedInput).finally(() => hideLoading());

    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [
    searchInput,
    // Dependencies (activeTab is excluded intentionally, using activeTabRef)
    setCaseSearchTerm,
    setTaskSearchTerm,
    setInvoiceSearchTerm,
    setLabelSearchTerm,
    setNoteSearchTerm,
    setExpenseSearchTerm,
    setUserSearchTerm,
    setClientSearchTerm,
    username,
    role,
    companyID
  ]);

  const isSearchActive = hasPerformedSearch && searchType !== "";

  const clearSearchState = useCallback(() => {
    setSearchResults([]);
    setsearchDetailSecData({});
    setSearchType("");
    setSearchMetadata({});
    setHasPerformedSearch(false);
    localStorage.setItem("hasSearched", "false");

    const searchInput = document.querySelector(".detailsection-search-input");
    if (searchInput) {
      searchInput.value = "";
    }
  }, [
    setSearchResults,
    setsearchDetailSecData,
    setSearchType,
    setSearchMetadata,
    setHasPerformedSearch,
  ]);

  // Add this function in DetailSection component
  const clearSearchInput = useCallback(() => {
    setSearchInput("");
  }, []);

  // Make this function available globally so MyClients can access it
  useEffect(() => {
    window.clearDetailSectionSearch = clearSearchInput;
    return () => {
      delete window.clearDetailSectionSearch;
    };
  }, [clearSearchInput]);


  const statsToDisplayCases = [
    {
      title: "Total Cases",
      value: detailSecData?.totalCases || 0,
      cardType: "total",
      isClickable: true,
      onClick: () => handleCaseCardClick(""), // Changed function name
      isActive: false, // Changed from selectedCard
    },
    {
      title: "Filtered Cases",
      value: hasActiveFilters
        ? totalFilteredCount // USE totalFilteredCount instead of filteredCases.length
        : detailSecData?.totalCases || 0,
    },
    {
      title: "Pending Cases",
      value: detailSecData?.pendingCaseCount || 0,
      cardType: "pending",
      isClickable: true,
      onClick: () => handleCaseCardClick("pending"), // Changed function name
      isActive: selectedCaseCard === "pending", // Changed from selectedCard
    },
    {
      title: "Closed Cases",
      value: detailSecData?.disposedCaseCount || 0,
      cardType: "closed",
      isClickable: true,
      onClick: () => handleCaseCardClick("closed"), // Changed function name
      isActive: selectedCaseCard === "closed", // Changed from selectedCard
    },
    {
      title: "Objection Raised",
      value: detailSecData?.totalObjections || 0,
      isClickable: true,
      cardType: "objection",
      onClick: () => handleCaseCardClick("objection"),
      isActive: selectedCaseCard === "objection",
    },
  ];

  const statsToDisplayTasks = [
    {
      title: "Total Tasks",
      value: TaskSecData?.totalTasks || 0,
      cardType: "total",
      isClickable: true,
      onClick: () => handleCardClick(""),
      isActive: false,
    },
    {
      title: "Today's Tasks",
      value: TaskSecData?.dueTodayCount || 0,
      cardType: "today",
      isClickable: true,
      onClick: () => handleCardClick("today"),
      isActive: selectedCard === "today",
    },
    {
      title: "Pending Tasks",
      value: TaskSecData?.pendingTasks || 0,
      cardType: "pending",
      isClickable: true,
      onClick: () => handleCardClick("pending"),
      isActive: selectedCard === "pending",
    },
    {
      title: "Completed Tasks",
      value: TaskSecData?.completedTasks || 0,
      cardType: "completed",
      isClickable: true,
      onClick: () => handleCardClick("completed"),
      isActive: selectedCard === "completed",
    },
  ];
  const statsToDisplayMyClients = [
    {
      title: "Total Clients",
      value: MyClientsData?.clientCount,
    },
  ];
  const statsToDisplayLabels = [
    {
      title: "Total Labels",
      value: LabelData?.total,
    },
  ];
  const statsToDisplayBranch = [
    {
      title: "Total Branch",
      value: BranchData?.totalBranches,
    },
  ];
  const statsToDisplayAddedUsers = [
    {
      title: "Total Added Users",
      value: AddUserData?.totalUsers || 0,
      cardType: "total",
      isClickable: true,
      onClick: () => handleUserCardClick(""),
      //isActive: selectedUserCard === "total",
      isActive: false,
    },
    {
      title: "Total Active Users",
      value: AddUserData?.activeUsers || 0,
      cardType: "active",
      isClickable: true,
      onClick: () => handleUserCardClick("active"),
      isActive: selectedUserCard === "active",
    },
    {
      title: "Total Inactive Users",
      value: AddUserData?.inactiveUsers || 0,
      cardType: "inactive",
      isClickable: true,
      onClick: () => handleUserCardClick("inactive"),
      isActive: selectedUserCard === "inactive",
    },
  ];
  const statsToDisplayNotes = [
    {
      title: "Total Notes",
      value: NotesData.total,
    },
  ];
  const statsToDisplayExpenses = [
    {
      title: "Total Expenses",
      value: ExpenseData?.expenseCount,
    },
    {
      title: "Total Amount",
      value: ExpenseData?.totalAmount,
    },
  ];
  // Helper to format numbers as 13.9k, 1.2M, etc.
  function formatNumberAbbr(num) {
    // Handle undefined, null, or invalid numbers
    if (num === undefined || num === null || num === "") return "0";
    if (typeof num !== "number") num = Number(num);
    if (isNaN(num)) return "0";

    // Round to 2 decimal places and remove trailing zeros
    return num.toFixed(2).replace(/\.00$/, '');
  }

  const statsToDisplayInvoices = [
    // {
    //   title: "Total Invoices",
    //   value: InvoiceData?.total || 0,
    //   cardType: "total",
    //   isClickable: true,
    //   onClick: () => handleInvoiceCardClick("total"),
    //   isActive: selectedInvoiceCard === "total",
    // },
    {
      title: "Total Invoices",
      value: InvoiceData?.total || 0,
      cardType: "total",
      isClickable: true,
      onClick: () => {
        // Clear all filters when clicking Total Invoices
        clearInvoiceFilters();
        // Also clear local filters in the Invoices component
        if (window.clearInvoiceFilters) {
          window.clearInvoiceFilters();
        }
        // Clear the search input in DetailSection
        if (window.clearDetailSectionSearch) {
          window.clearDetailSectionSearch();
        }
        // Reset the card selection
        handleInvoiceCardClick(null);
      },
      isActive: selectedInvoiceCard === "total",
    },
    {
      title: "Paid Invoices",
      value: (
        <>
          {InvoiceData?.totalPaid || 0} -{" "}
          <span className="currency-symbol">{currencySign}</span>
          {formatNumberAbbr(InvoiceData?.totalAmountPaid || 0)}
        </>
      ),
      cardType: "paid",
      isClickable: true,
      onClick: () => handleInvoiceCardClick("paid"),
      isActive: selectedInvoiceCard === "paid",
    },
    {
      title: "Part-Pay Invoices",
      value: (
        <>
          {InvoiceData?.totalPartPayment || 0} -{" "}
          <span className="currency-symbol">{currencySign}</span>
          {formatNumberAbbr(InvoiceData?.totalAmountPartPayment || 0)}
        </>
      ),
      cardType: "part-payment",
      isClickable: true,
      onClick: () => handleInvoiceCardClick("part-payment"),
      isActive: selectedInvoiceCard === "part-payment",
    },
    {
      title: "Pending Invoices",
      value: (
        <>
          {InvoiceData?.totalPending || 0} -{" "}
          <span className="currency-symbol">{currencySign}</span>
          {formatNumberAbbr(InvoiceData?.totalAmountPending || 0)}
        </>
      ),
      cardType: "pending",
      isClickable: true,
      onClick: () => handleInvoiceCardClick("pending"),
      isActive: selectedInvoiceCard === "pending",
    },
    {
      title: "Cancelled Invoices",
      value: (
        <>
          {InvoiceData?.totalCancelled || 0} -{" "}
          <span className="currency-symbol">{currencySign}</span>
          {formatNumberAbbr(InvoiceData?.totalAmountCancelled || 0)}
        </>
      ),
      cardType: "cancelled",
      isClickable: true,
      onClick: () => handleInvoiceCardClick("cancelled"),
      isActive: selectedInvoiceCard === "cancelled",
    },
  ];

  const handleNewButtonClick = async () => {
    if (activeTab === "Cases") {
      // Check if we're still loading case limit data
      if (isCaseLimitLoading) {
        showToast("Loading case data, please wait...", "info");
        return;
      }

      // Use preloaded data for instant check
      if (!caseLimitData) {
        // Fallback: fetch if not available
        try {
          showToast("Checking case limit...", "info");
          await refreshCaseLimitData();
          // Data will be available after refresh, check on next render
          return;
        } catch (error) {
          console.error("Error fetching case limit:", error);
          showToast("Error checking case limit. Please try again.", "error");
          return;
        }
      }

      // Use preloaded data for instant check
      const totalCases = Number(caseLimitData?.cases?.totalCases || 0);
      const caseLimit = Number(caseLimitData?.limit?.caseLimit || 0);


      if (totalCases >= caseLimit) {
        showToast(
          "You have reached the case limit for your plan. Please contact your administrator",
          "warning"
        );
        return;
      }

      navigate("/home/cases/newcase");
      return;
    }

    if (activeTab === "Manage Users") {
      if (isUserLimitLoading) {
        showToast("Loading user data, please wait...", "info");
        return;
      }
      if (!userLimitData) {
        try {
          showToast("Checking user limit...", "info");
          const response = await getUserLimit();
          setUserLimitData(response.data);

          const userLimit = Number(response.data.limit.usersLimit);
          const activeUsers = Number(AddUserData?.activeUsers || 0);

          if (activeUsers >= userLimit) {
            setIsUserLimitModalOpen(true);
            return;
          }

          navigate("/home/addusers/add-user");
        } catch (error) {
          console.error("Error fetching user limit:", error);
          showToast("Error checking user limit. Please try again.", "error");
        }

        return;
      }

      // Use preloaded data for instant check
      const userLimit = Number(userLimitData.limit.usersLimit);
      const activeUsers = Number(AddUserData?.activeUsers || 0);

      if (activeUsers >= userLimit) {
        setIsUserLimitModalOpen(true);
        return;
      }

      navigate("/home/addusers/add-user");
    } else if (activeTab === "Tasks") {
      navigate("/home/tasks/newtask");
    } else if (activeTab === "Labels") {
      navigate("/home/labels/newlabel");
    } else if (activeTab === "Expenses") {
      navigate("/home/expenses/newexpense");
    } else if (activeTab === "Notes") {
      navigate("/home/notes/newnote");
    } else if (activeTab === "Branch") {
      setIsNewBranchModalOpen(true);
    } else if (activeTab === "Add My Clients") {
      navigate("/home/my-clients/add-client");
    } else if (activeTab === "Invoices") {
      navigate("/home/invoices/add");
    } else {
      navigate("/case");
    }
  };
  const getSearchPlaceholder = () => {
    switch (activeTab) {
      case "Cases":
        return "Search cases...";
      case "Tasks":
        return "Search tasks...";
      case "Expenses":
        return "Search expenses...";
      case "Labels":
        return "Search labels...";
      case "Add My Clients":
        return "Search clients...";
      case "Invoices":
        return "Search invoices...";
      case "Notes":
        return "Search notes...";
      case "Branch":
        return "Search branches...";
      case "Manage Users":
        return "Search users...";
      default:
        return "Search...";
    }
  };

  const caseFileInputRef = useRef(null);
  const userFileInputRef = useRef(null);

  const [isImportClientsModalOpen, setIsImportClientsModalOpen] =
    useState(false);
  const clientFileInputRef = useRef(null);

  // Add this function for sample sheet download
  const handleCaseSampleSheetDownload = async () => {
    try {
      const response = await fetch(caseSampleSheet);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "sample_cases_template.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      showToast("Sample sheet downloaded successfully!", "success");
    } catch (error) {
      console.error("Error downloading sample sheet:", error);
      showToast("Failed to download sample sheet.", "error");
    }
  };

  // User sample sheet download
  const handleUserSampleSheetDownload = async () => {
    try {
      const response = await fetch(userSampleSheet);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "sample_users_template.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      showToast("Sample sheet downloaded successfully!", "success");
    } catch (error) {
      console.error("Error downloading sample sheet:", error);
      showToast("Failed to download sample sheet.", "error");
    }
  };

  // Drag and drop handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const files = e.dataTransfer.files;
    if (files && files[0]) {
      // Manually trigger the file input change with the dropped file
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(files[0]);
      caseFileInputRef.current.files = dataTransfer.files;

      // Trigger the change event
      const event = new Event("change", { bubbles: true });
      caseFileInputRef.current.dispatchEvent(event);
    }
  };

  const handleClientDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleClientDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const files = e.dataTransfer.files;
    if (files && files[0]) {
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(files[0]);
      clientFileInputRef.current.files = dataTransfer.files;

      const event = new Event("change", { bubbles: true });
      clientFileInputRef.current.dispatchEvent(event);
    }
  };

  const handleClientFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls)$/)) {
      showToast("Please upload a valid Excel file (.xlsx or .xls)", "error");
      return;
    }

    try {
      showLoading();
      const formData = new FormData();
      formData.append("file", file);

      const response = await uploadClientsSpreadsheet(formData);

      // Extract response data
      const responseData = response?.data?.data || response?.data;
      const errors = responseData?.errors || [];
      const processed = responseData?.processed || 0;
      const created = responseData?.created || 0;
      const duplicates = responseData?.duplicates || 0;

      // Check if there are errors
      if (errors.length > 0) {
        // Show all errors line by line
        const errorMessage = errors.join("\n");
        showToast(errorMessage, "error", 5000); // 5 seconds for multiple errors
      } else {
        showToast(
          `Successfully uploaded! ${processed} client(s) processed, ${created} new client(s) added${duplicates > 0 ? `, ${duplicates} duplicate(s) skipped` : ""
          }.`,
          "success"
        );
      }

      // Close the import modal on successful upload (even if there are duplicates)
      setIsImportClientsModalOpen(false);

      // ✅ IMPORTANT: Refresh client data by triggering context refresh
      triggerClientRefresh();

    } catch (err) {
      console.error("Error uploading clients spreadsheet:", err);
      showToast(
        err?.response?.data?.message || "Failed to upload spreadsheet.",
        "error"
      );
    } finally {
      hideLoading();
      if (clientFileInputRef.current) {
        clientFileInputRef.current.value = "";
      }
    }
  };
  const handleClientSampleSheetDownload = async () => {
    try {
      // You'll need to add the actual sample sheet file to your assets
      const response = await fetch(clientSampleSheet);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "sample_clients_template.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      showToast("Sample sheet downloaded successfully!", "success");
    } catch (error) {
      console.error("Error downloading sample sheet:", error);
      showToast("Failed to download sample sheet.", "error");
    }
  };

  // Drag and drop handlers for users
  const handleUserDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleUserDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const files = e.dataTransfer.files;
    if (files && files[0]) {
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(files[0]);
      userFileInputRef.current.files = dataTransfer.files;

      const event = new Event("change", { bubbles: true });
      userFileInputRef.current.dispatchEvent(event);
    }
  };

  // User file change handler
  const handleUserFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls)$/)) {
      showToast("Please upload a valid Excel file (.xlsx or .xls)", "error");
      return;
    }

    try {
      showLoading();
      const formData = new FormData();
      formData.append("file", file);

      await uploadUsersSpreadsheetUsers(formData);
      showToast("Users spreadsheet uploaded successfully!", "success");

      // Close the import modal on successful upload
      setIsImportUsersModalOpen(false);

      // Refresh user data
      const res = await getHierarchy();
      const userData = res.data.users || [];
      setAddUserData(res.data);
      setFilteredUsers(userData);
    } catch (err) {
      console.error("Error uploading users spreadsheet:", err);
      showToast(
        err?.response?.data?.message || "Failed to upload spreadsheet.",
        "error"
      );
    } finally {
      hideLoading();
      if (userFileInputRef.current) {
        userFileInputRef.current.value = "";
      }
    }
  };

  const handleCaseFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.name.match(/\.(xlsx|xls)$/)) {
      showToast("Please upload a valid Excel file (.xlsx or .xls)", "error");
      return;
    }

    try {
      showLoading();

      // ✅ STEP 1: Read the Excel file to count rows (excluding header)
      const XLSX = await import("xlsx");
      const fileBuffer = await file.arrayBuffer();
      const workbook = XLSX.read(fileBuffer, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      const jsonDataWithHeaders = XLSX.utils.sheet_to_json(worksheet);

      // Count rows excluding the header row
      const totalRowsInFile = jsonDataWithHeaders.length;


      // ✅ STEP 2: Check case limit
      const currentTotalCases = Number(caseLimitData?.cases?.totalCases || 0);
      const caseLimit = Number(caseLimitData?.limit?.caseLimit || 0);

      // ✅ STEP 3: Prevent upload if limit will be exceeded
      if (currentTotalCases + totalRowsInFile > caseLimit) {
        hideLoading();
        setIsCaseLimitModalOpen(true);
        if (caseFileInputRef.current) {
          caseFileInputRef.current.value = "";
        }
        return;
      }

      // ✅ STEP 4: Proceed with upload if within limit
      const formData = new FormData();
      formData.append("file", file);

      const response = await uploadCasesSpreadsheet(formData);

      // Extract response data - handle nested structure
      const responseData = response?.data?.data || response?.data;
      const errors = responseData?.errors || [];
      const processedCases = responseData?.processedCases || 0;
      const newCases = responseData?.newCases || 0;
      const existingCases = responseData?.existingCases || 0;

      // Check if there are errors
      if (errors.length > 0) {
        // Check if it's a missing fields error (single general error)
        if (errors[0].includes("Missing required fields")) {
          showToast(
            "Missing required fields (Court Type, Parties, Court Name, or Cnr No). Please check the sample sheet and try again.",
            "error"
          );
        } else {
          // For duplicate cases, show all errors line by line
          const errorMessage = errors.join("\n");
          showToast(errorMessage, "error", 1000);
        }
        console.error("Upload errors:", errors);
      } else {
        showToast(
          `Successfully uploaded! ${processedCases} case(s) processed, ${newCases} new case(s) added${existingCases > 0
            ? `, ${existingCases} existing case(s) skipped`
            : ""
          }.`,
          "success"
        );

        // Close the import modal on successful upload
        setIsImportCasesModalOpen(false);

        // Refresh case limit data and cases list
        await refreshCaseLimitData();

        // Trigger case list refresh to show newly imported cases
        triggerCaseRefresh();
      }
    } catch (err) {
      console.error("Error uploading cases spreadsheet:", err);
      console.error("Error details:", {
        message: err.message,
        code: err.code,
        status: err.response?.status,
        data: err.response?.data,
        config: {
          url: err.config?.url,
          method: err.config?.method,
          baseURL: err.config?.baseURL,
        },
      });

      // Handle different types of errors with specific messages
      if (err.code === "ERR_NETWORK" || err.message === "Network Error") {
        showToast(
          "Cannot connect to server. Please verify:\n1. Backend server is running\n2. API endpoint 'case/add-cases-spreadsheet' exists\n3. Network connection is stable",
          "error"
        );
      } else if (err.response?.status === 404) {
        showToast(
          "API endpoint not found. Please contact the administrator to verify the backend route '/case/add-cases-spreadsheet' exists.",
          "error"
        );
      } else if (err.response?.status === 413) {
        showToast(
          "File is too large. Please upload a smaller file or increase server file size limit.",
          "error"
        );
      } else if (err.response?.status === 400) {
        showToast(
          err.response?.data?.message ||
          "Invalid file format. Please check the sample sheet and ensure all required fields are present.",
          "error"
        );
      } else if (err.response?.status === 401 || err.response?.status === 403) {
        showToast("Authentication error. Please log in again.", "error");
      } else if (err.response?.status === 500) {
        showToast(
          "Server error occurred while processing your file. Please try again or contact support.",
          "error"
        );
      } else {
        showToast(
          err?.response?.data?.message ||
          "Failed to upload spreadsheet. Please try again.",
          "error"
        );
      }
    } finally {
      hideLoading();
      if (caseFileInputRef.current) {
        caseFileInputRef.current.value = "";
      }
    }
  };
  return (
    <>
      <div className="detailsection-dashboard-wrapper">
        <div className="detailsection-dashboard-header">
          <div className="detailsection-right-buttons ">
            {role !== "customer" && (
              <button className="new-case-btn" onClick={handleNewButtonClick}>
                + New{" "}
                {activeTab === "Cases"
                  ? "Case"
                  : activeTab === "Tasks"
                    ? "Task"
                    : activeTab === "Manage Users"
                      ? "User"
                      : activeTab === "Add My Clients"
                        ? "Client"
                        : activeTab}
              </button>
            )}
            {activeTab !== "Branch" && (
              // <input
              //   type="text"
              //   placeholder={getSearchPlaceholder()}
              //   className="detailsection-search-input"
              //   value={searchInput}
              //   onChange={(e) => setSearchInput(e.target.value)}
              // />
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="text"
                  placeholder={getSearchPlaceholder()}
                  className="detailsection-search-input"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  onKeyDown={(e) => {
                    const manualTabs = ["Cases", "Tasks", "Invoices", "Expenses", "Notes", "Manage Users", "Add My Clients"];

                    if (manualTabs.includes(activeTab) && e.key === 'Enter') {
                      triggerSearch();
                    }
                  }}
                />

                {/* Search Icon Button - Outside and Aligned */}
                {["Cases", "Tasks", "Invoices", "Expenses", "Notes", "Manage Users", "Add My Clients"].includes(activeTab) && (
                  <div
                    onClick={triggerSearch}
                    style={{
                      height: '35px',              // Matches typical input height
                      width: '35px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#ffffff',
                      border: '1px solid #d1d1d1', // Light grey border to match inputs
                      borderRadius: '6px',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
                    title="Click to Search"
                  >
                    <MdSearch
                      size={20}
                      color="#666"
                    />
                  </div>
                )}
              </div>

            )}
          </div>

          {(isCases ||
            isTasks ||
            isInvoices ||
            isMyClients ||
            activeTab === "Manage Users") && (
              <div className="detailsection-right-buttons">
                {isCases && role !== "customer" && (
                  <>
                    <button
                      className="detailsection-export-btn"
                      onClick={() => setIsImportCasesModalOpen(true)}
                    >
                      Import Cases
                    </button>
                  </>
                )}
                {activeTab === "Manage Users" && (
                  <>
                    <button
                      className="detailsection-export-btn"
                      onClick={() => setIsImportUsersModalOpen(true)}
                    >
                      Import Users
                    </button>
                  </>
                )}
                {activeTab === "Add My Clients" && (
                  <>
                    <button
                      className="detailsection-export-btn"
                      onClick={() => setIsImportClientsModalOpen(true)}
                    >
                      Import Clients
                    </button>
                  </>
                )}
                {/* {isTasks && (
                <>
                  <button className="detailsection-export-btn">
                    Sample Sheet
                  </button>
                  <button className="detailsection-export-btn">
                    Import cases
                  </button>
                </>
              )} */}
                {(isCases || isTasks || isInvoices || isMyClients) && (
                  <button
                    className="detailsection-export-btn"
                    onClick={async () => {
                      if (activeTab === "Cases") {
                        setIsPdfExportModalOpen(true);
                      } else if (activeTab === "Tasks") {
                        await exportTasksToExcel(
                          searchResults.length > 0
                            ? searchResults
                            : TaskSecData.tasks,
                          showToast
                        );
                      } else if (activeTab === "Invoices") {
                        setIsInvoiceExportModalOpen(true);
                      } else if (activeTab === "Add My Clients") {
                        // Export all clients functionality
                        try {
                          showLoading();

                          // Fetch ALL clients without pagination
                          const response = await getMyClients();
                          const allClients = response?.data?.client || [];

                          if (allClients.length === 0) {
                            showToast(
                              "No clients available to export",
                              "warning"
                            );
                            return;
                          }

                          await exportClientsToExcel(allClients, "all_clients");
                          showToast(
                            `Successfully exported ${allClients.length} clients to Excel`,
                            "success"
                          );
                        } catch (error) {
                          console.error("Error exporting clients:", error);
                          showToast(
                            "Failed to export clients. Please try again.",
                            "error"
                          );
                        } finally {
                          hideLoading();
                        }
                      }
                    }}
                  >
                    <img
                      src={impexp}
                      alt="impexp"
                      className="detailsection-impexpicon"
                    />
                    {activeTab === "Cases" && "Export Cases"}
                    {activeTab === "Tasks" && "Export Tasks"}
                    {activeTab === "Invoices" && "Export Invoices"}
                    {activeTab === "Add My Clients" && "Export Clients"}
                  </button>
                )}
              </div>
            )}
        </div>
        <div className="detailsection-dashboard-cards">
          {activeTab === "Cases" &&
            statsToDisplayCases.map((item, index) => (
              <DetailCard
                key={index}
                title={item.title}
                value={item.value}
                onClick={item.onClick}
                isClickable={item.isClickable}
                isActive={item.isActive}
                cardType={item.cardType}
              />
            ))}
          {activeTab === "Tasks" &&
            statsToDisplayTasks.map((item, index) => (
              <DetailCard
                key={index}
                title={item.title}
                value={item.value}
                onClick={item.onClick}
                isClickable={item.isClickable}
                isActive={item.isActive}
                cardType={item.cardType}
              />
            ))}
          {activeTab === "Manage Users" &&
            statsToDisplayAddedUsers.map((item, index) => (
              <DetailCard
                key={index}
                title={item.title}
                value={item.value}
                onClick={item.onClick}
                isClickable={item.isClickable}
                isActive={item.isActive}
                cardType={item.cardType}
              />
            ))}
          {activeTab === "Add My Clients" &&
            statsToDisplayMyClients.map((item, index) => (
              <DetailCard key={index} title={item.title} value={item.value} />
            ))}
          {activeTab === "Labels" &&
            statsToDisplayLabels.map((item, index) => (
              <DetailCard key={index} title={item.title} value={item.value} />
            ))}
          {activeTab === "Branch" &&
            statsToDisplayBranch.map((item, index) => (
              <DetailCard key={index} title={item.title} value={item.value} />
            ))}
          {activeTab === "Notes" &&
            statsToDisplayNotes.map((item, index) => (
              <DetailCard key={index} title={item.title} value={item.value} />
            ))}
          {activeTab === "Expenses" &&
            statsToDisplayExpenses.map((item, index) => (
              <DetailCard key={index} title={item.title} value={item.value} />
            ))}
          {activeTab === "Invoices" &&
            statsToDisplayInvoices.map((item, index) => (
              <DetailCard
                key={index}
                title={item.title}
                value={item.value}
                onClick={item.onClick}
                isClickable={item.isClickable}
                isActive={item.isActive}
                cardType={item.cardType}
              />
            ))}
        </div>

        {isPdfExportModalOpen && (
          <CommonModal onClose={() => setIsPdfExportModalOpen(false)}>
            <div className="pdf-export-modal">
              <h2 className="export-modal-title">Export Cases to PDF</h2>

              {/* Orientation Selection */}
              <div className="export-modal-options">
                <label className="export-modal-option">
                  <input
                    type="radio"
                    value="portrait"
                    checked={pdfOrientation === "portrait"}
                    onChange={(e) => setPdfOrientation(e.target.value)}
                  />
                  <span>Portrait Orientation</span>
                </label>
                <p className="export-modal-desc">
                  Default detailed view - Best for comprehensive case
                  information
                </p>

                <label className="export-modal-option">
                  <input
                    type="radio"
                    value="landscape"
                    checked={pdfOrientation === "landscape"}
                    onChange={(e) => setPdfOrientation(e.target.value)}
                  />
                  <span>Landscape Orientation</span>
                </label>
                <p className="export-modal-desc">
                  Wide view with more columns - Best for tabular data display
                </p>
              </div>

              <div className="export-modal-actions">
                <button
                  className="btn-cancel"
                  onClick={() => setIsPdfExportModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn-export"
                  onClick={() => handleExportPDF(pdfOrientation)}
                >
                  Export to PDF
                </button>
              </div>
            </div>
          </CommonModal>
        )}
        {isInvoiceExportModalOpen && (
          <CommonModal onClose={() => setIsInvoiceExportModalOpen(false)}>
            <div className="invoice-export-modal">
              <h3>Export Invoices</h3>
              <p className="export-subtext">
                Choose filters and export invoices in Excel format
              </p>

              <div className="filter-sections">
                {/* Status Filter */}
                <div className="filter-section">
                  <h4 className="filter-title">Payment Status</h4>
                  <div className="filter-options">
                    {["all", "pending", "paid", "part-payment"].map(
                      (status) => (
                        <label key={status} className="filter-option">
                          <input
                            type="radio"
                            name="status"
                            value={status}
                            checked={selectedStatus === status}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                          />
                          <span className="filter-label">
                            {status === "all"
                              ? "All Statuses"
                              : status === "part-payment"
                                ? "Part Payment"
                                : status.charAt(0).toUpperCase() +
                                status.slice(1)}
                          </span>
                        </label>
                      )
                    )}
                  </div>
                </div>
                <div className="filter-section">
                  <h4 className="filter-title">Date Range</h4>
                  <div className="filter-options">
                    {[
                      {
                        value: "current-month",
                        label: "Current Month (August 2025)",
                      },
                      { value: "last-month", label: "Last Month (July 2025)" },
                      { value: "june-2025", label: "June 2025" },
                      { value: "may-2025", label: "May 2025" },
                      { value: "april-2025", label: "April 2025" },
                      { value: "march-2025", label: "March 2025" },
                      {
                        value: "previous-fy",
                        label: "Previous Financial Year",
                      },
                      { value: "select-range", label: "Select Date Range" },
                    ].map((dateRange) => (
                      <label key={dateRange.value} className="filter-option">
                        <input
                          type="radio"
                          name="dateRange"
                          value={dateRange.value}
                          checked={selectedDateRange === dateRange.value}
                          onChange={(e) => {
                            setSelectedDateRange(e.target.value);
                          }}
                        />
                        <span className="filter-label">{dateRange.label}</span>
                      </label>
                    ))}
                  </div>

                  {/* Show date inputs when "Select Date Range" is selected */}
                  {selectedDateRange === "select-range" && (
                    <div className="date-range-inputs">
                      <div className="date-input-group">
                        <label>Start Date:</label>
                        <input
                          type="date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>
                      <div className="date-input-group">
                        <label>End Date:</label>
                        <input
                          type="date"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="export-actions">
                <button
                  className="export-btn cancel-btn"
                  onClick={() => {
                    setSelectedStatus("all");
                    setSelectedDateRange("current-month");
                    setStartDate("");
                    setEndDate("");
                    setIsInvoiceExportModalOpen(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="export-btn export-btn-primary"
                  onClick={handleInvoiceExport}
                >
                  Export Invoices
                </button>
              </div>
            </div>
          </CommonModal>
        )}
        {isNewBranchModalOpen && (
          <CommonModal onClose={() => setIsNewBranchModalOpen(false)}>
            <BranchForm
              onClose={() => setIsNewBranchModalOpen(false)}
              companyID={companyID}
              showToast={showToast}
              onSuccess={() => {
                setIsNewBranchModalOpen(false);
                window.location.reload();
              }}
            />
          </CommonModal>
        )}

        {isUserLimitModalOpen && (
          <CommonModal onClose={() => setIsUserLimitModalOpen(false)}>
            <div className="user-limit-modal">
              <div className="limit-icon">⚠️</div>
              <h3>User Limit Reached</h3>
              <p className="limit-message">
                You have reached your maximum user limit. To add more users, you
                can:
              </p>
              <div className="limit-options">
                <div
                  className="limit-option clickable"
                  onClick={() => setIsUserLimitModalOpen(false)}
                >
                  <span className="option-icon">🗑️</span>
                  <span>Delete or deactivate existing users</span>
                </div>
                <div
                  className="limit-option clickable"
                  onClick={() => {
                    setIsUserLimitModalOpen(false);
                    window.open(
                      "http://lawsuit-pro.com/pricing.html",
                      "_blank"
                    );
                  }}
                >
                  <span className="option-icon">⬆️</span>
                  <span>Upgrade your plan for more users</span>
                </div>
              </div>
              <div className="limit-actions">
                <button
                  className="limit-btn secondary"
                  onClick={() => setIsUserLimitModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="limit-btn primary"
                  onClick={() => {
                    setIsUserLimitModalOpen(false);
                    window.open(
                      "http://lawsuit-pro.com/pricing.html",
                      "_blank"
                    );
                  }}
                >
                  Upgrade Plan
                </button>
              </div>
            </div>
          </CommonModal>
        )}

        {isImportCasesModalOpen && (
          <CommonModal onClose={() => setIsImportCasesModalOpen(false)}>
            <div className="import-clients-modal">
              <h2 className="import-modal-title">Import Cases</h2>

              <div className="import-modal-content">
                <div
                  className="upload-section"
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  onClick={() => caseFileInputRef.current.click()}
                  style={{ cursor: "pointer" }}
                >
                  <div className="upload-icon-container">
                    <svg
                      className="upload-icon"
                      width="34"
                      height="34"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="17 8 12 3 7 8" />
                      <line x1="12" y1="3" x2="12" y2="15" />
                    </svg>
                  </div>
                  <p className="upload-text">
                    Drag-and-drop documents here
                    <br />
                    (or click to browse...)
                  </p>
                  <button
                    className="browse-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      caseFileInputRef.current.click();
                    }}
                  >
                    Browse Files
                  </button>
                </div>
                <div className="modal-actions">
                  <button
                    className="action-btn download-btn"
                    onClick={handleCaseSampleSheetDownload}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7 10 12 15 17 10" />
                      <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                    Download sample file
                  </button>
                  <button
                    className="action-btn close-btn"
                    onClick={() => setIsImportCasesModalOpen(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </CommonModal>
        )}

        {isImportUsersModalOpen && (
          <CommonModal onClose={() => setIsImportUsersModalOpen(false)}>
            <div className="import-clients-modal">
              <h2 className="import-modal-title">Import Users</h2>
              <div className="import-modal-content">
                <div
                  className="upload-section"
                  onDragOver={handleUserDragOver}
                  onDrop={handleUserDrop}
                  onClick={() => userFileInputRef.current.click()}
                  style={{ cursor: "pointer" }}
                >
                  <div className="upload-icon-container">
                    <svg
                      className="upload-icon"
                      width="34"
                      height="34"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="17 8 12 3 7 8" />
                      <line x1="12" y1="3" x2="12" y2="15" />
                    </svg>
                  </div>
                  <p className="upload-text">
                    Drag-and-drop documents here
                    <br />
                    (or click to browse...)
                  </p>
                  <button
                    className="browse-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      userFileInputRef.current.click();
                    }}
                  >
                    Browse Files
                  </button>
                </div>
                <div className="modal-actions">
                  <button
                    className="action-btn download-btn"
                    onClick={handleUserSampleSheetDownload}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7 10 12 15 17 10" />
                      <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                    Download sample file
                  </button>
                  <button
                    className="action-btn close-btn"
                    onClick={() => setIsImportUsersModalOpen(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </CommonModal>
        )}

        {isImportClientsModalOpen && (
          <CommonModal onClose={() => setIsImportClientsModalOpen(false)}>
            <div className="import-clients-modal">
              <h2 className="import-modal-title">Import Clients</h2>
              <div className="import-modal-content">
                <div
                  className="upload-section"
                  onDragOver={handleClientDragOver}
                  onDrop={handleClientDrop}
                  onClick={() => clientFileInputRef.current.click()}
                  style={{ cursor: "pointer" }}
                >
                  <div className="upload-icon-container">
                    <svg
                      className="upload-icon"
                      width="34"
                      height="34"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="17 8 12 3 7 8" />
                      <line x1="12" y1="3" x2="12" y2="15" />
                    </svg>
                  </div>
                  <p className="upload-text">
                    Drag-and-drop documents here
                    <br />
                    (or click to browse...)
                  </p>
                  <button
                    className="browse-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      clientFileInputRef.current.click();
                    }}
                  >
                    Browse Files
                  </button>
                </div>
                <div className="modal-actions">
                  <button
                    className="action-btn download-btn"
                    onClick={handleClientSampleSheetDownload}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7 10 12 15 17 10" />
                      <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                    Download sample file
                  </button>
                  <button
                    className="action-btn close-btn"
                    onClick={() => setIsImportClientsModalOpen(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </CommonModal>
        )}
      </div>

      {/* Hidden file input for client import */}
      <input
        type="file"
        ref={clientFileInputRef}
        style={{ display: "none" }}
        accept=".xlsx,.xls"
        onChange={handleClientFileChange}
      />

      {/* Hidden file input for case import */}
      <input
        type="file"
        ref={caseFileInputRef}
        style={{ display: "none" }}
        accept=".xlsx,.xls"
        onChange={handleCaseFileChange}
      />

      {/* Hidden file input for user import */}
      <input
        type="file"
        ref={userFileInputRef}
        style={{ display: "none" }}
        accept=".xlsx,.xls"
        onChange={handleUserFileChange}
      />

      {isCaseLimitModalOpen && (
        <CommonModal onClose={() => setIsCaseLimitModalOpen(false)}>
          <div className="user-limit-modal compact-limit-modal">
            <div className="limit-icon">⚠️</div>
            <h3>Case Limit Exceeded</h3>
            <p className="limit-message">
              This upload would exceed your case limit.
            </p>
            <div className="limit-stats-compact">
              <div className="stat-item">
                <span className="stat-label">Current:</span>
                <span className="stat-value">
                  {caseLimitData?.cases?.totalCases || 0}
                </span>
              </div>
              <div className="stat-divider">/</div>
              <div className="stat-item">
                <span className="stat-label">Limit:</span>
                <span className="stat-value">
                  {caseLimitData?.limit?.caseLimit || 0}
                </span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Available:</span>
                <span className="stat-value">
                  {(caseLimitData?.limit?.caseLimit || 0) -
                    (caseLimitData?.cases?.totalCases || 0)}
                </span>
              </div>
            </div>
            <p className="limit-message-small">
              Reduce cases in spreadsheet or upgrade your plan.
            </p>
            <div className="limit-actions-compact">
              <button
                className="limit-btn secondary"
                onClick={() => setIsCaseLimitModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="limit-btn primary"
                onClick={() => {
                  setIsCaseLimitModalOpen(false);
                  window.open("http://lawsuit-pro.com/pricing.html", "_blank");
                }}
              >
                Upgrade
              </button>
            </div>
          </div>
        </CommonModal>
      )}
    </>
  );
};
